module.exports = __webpack_public_path__ + "assets/img/5_1303.7c82ac05.jpg";